module.exports = __webpack_public_path__ + "static/logo-c712b684c95357d716c2f8aa8dbd35ce.png";